import { Navigate, Outlet } from 'react-router-dom'

export default function ProtectedRoute() {
    const allowed = Boolean(localStorage.token && localStorage.user && localStorage.permissions)
    return allowed ? <Outlet /> : <Navigate to="/" replace />
}
